import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class Unfiltered extends SeoHeadingHandler {

	public async canHandle(sortState: SortingState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);

		return metaRankingSortSelected;
	}

	protected selfHandle(): Promise<string> {

		const year = this.getCurrentYearForSeo();

		const seoInfo = `World university rankings ${year} | Studyportals University Meta Ranking`;

		return Promise.resolve(seoInfo);
	}
}
